// extracted by mini-css-extract-plugin
export var skeletonContainer = "b7_hL";